export default __webpack_public_path__ + "static/media/password_icon.d9e06820.svg";